import { Dropdown as AntdDropdown } from "antd";
import type { DropdownProps as AntdDropdownProps } from "antd";

export type DropdownProps = AntdDropdownProps;

const Dropdown = AntdDropdown;

export default Dropdown;

